"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var isInsideBoundaries = function isInsideBoundaries(_ref) {
  var $container = _ref.$container,
      $element = _ref.$element,
      align = _ref.align;

  if ($container && $element) {
    var containerRect = $container.getBoundingClientRect();
    var elementRect = $element.getBoundingClientRect();
    var alignVert = ["bottom", "top"].includes(align); // avoid some weirdness with the tip and with scrollbars
    // we might actually want the dimensions of the Tip to do this right
    // half tip + edgePadding

    var edgeBuffer = {
      vert: alignVert ? 0 : 15,
      horz: alignVert ? 15 : 0
    }; // ¿ maybe just round up to 20 ?

    var scrollbarBuffer = 17;
    var elementLimit = {
      left: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.right,
      right: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.left + scrollbarBuffer,
      top: alignVert ? elementRect.bottom : elementRect.bottom - elementRect.height / 2,
      bottom: alignVert ? elementRect.top + scrollbarBuffer : elementRect.bottom - elementRect.height / 2
    };
    return elementLimit.top - edgeBuffer.vert >= containerRect.top && elementLimit.bottom + edgeBuffer.vert <= containerRect.bottom && elementLimit.right + edgeBuffer.horz <= containerRect.right && elementLimit.left - edgeBuffer.horz >= containerRect.left;
  }

  return true;
};

var _default = isInsideBoundaries;
exports["default"] = _default;
//# sourceMappingURL=isInsideBoundaries.js.map